import {UntypedFormGroup} from '@angular/forms';

export class FormDialogParent {
  form: UntypedFormGroup;
  showErrors = false;
  self = this;
}
